import styled, { css } from "styled-components";
import DetailLine from "../../../../../components/DetailLine/DetailLine";
import { breakpoints } from "../../../../../utils/breakpoints";
import { useRouter } from "next/router";

export function Banners({ slide, properties, isMobile }) {
	const router = useRouter();

	const onClickBannerButton = (href) => {
		router.push(href);
	};

	return (
		<BannerComponent
			color={slide.color}
			id={slide.id}
			backgroundImg={slide.backgroundImg}
			properties={properties}
			isTransformSolution={slide.id === 1}
		>
			<div className="text-container">
				<div className="title-line">
					<DetailLine color={slide.color} />
					{isMobile ? (
						<div className="title-line min-title">
							{slide.titleLines.map((line, index) =>
								line.map((textObject, index) => (
									<span
										key={index}
										className={
											textObject.highlighted ? "highlighted" : "title-line"
										}
									>
										{textObject.text.includes("<br/>")
											? textObject.text.replace("<br/>", "")
											: textObject.text}
										{textObject.text.includes("<br/>") ? <br /> : null}
									</span>
								)),
							)}
						</div>
					) : (
						slide.titleLines.map((line, index) => (
							<div key={index} className="title-line title-marg">
								{line.map((textObject, index) => (
									<span
										key={index}
										className={
											textObject.highlighted ? "highlighted" : "title-line"
										}
									>
										{textObject.text.includes("<br/>")
											? textObject.text.replace("<br/>", "")
											: textObject.text}
									</span>
								))}
							</div>
						))
					)}
				</div>
				<div className="text">
					{slide.text}
					<button onClick={() => onClickBannerButton(slide.href)}>
						{slide.buttonText}
					</button>
				</div>
			</div>
			<div className="gptw">
				<img src="/landings/assets/icons/gptw.svg" alt="Gptw" />
			</div>
			<div className="swiper-pagination"></div>
		</BannerComponent>
	);
}

const BannerComponent = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  background-image: url(${(props) => `${props.backgroundImg}`});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: ${(props) =>
		props.isTransformSolution ? "right" : "center"};
  padding: 56px 26px 0px 26px;

  .gptw {
    display: none;
  }

  .text-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100% - 11vh);
    padding-bottom: 20px;
    
    @media screen and (min-height: 375px) and (max-width: 991px) {
      margin-top: 10vh;
    }

    .text {
      font-size: 1.3rem;
      line-height: 32px;
      max-width: 696px;
      color: #ffffff;
      font-family: "Hind Madurai";

      display: flex;
      flex-direction: column;
      margin-bottom: 8vw;
    }

    .highlighted {
      color: ${(props) => props.color};
      font-weight: 700;
      font-family: "Hind Madurai";
      margin-bottom: 8px;
    }
  }

  button {
    font-size: 12px;
    border: 1.5px solid ${(props) => props.color};
    color: ${(props) => props.color};
    border-radius: 100px;
    background: transparent;
    font-weight: 500;
    font-family: "Hind Madurai";
    margin-top: 8vw;
    word-spacing: 2px;
    letter-spacing: 1.4px;

    @media (max-width: ${breakpoints.m}) {
      height: 48px;
      padding-top: 1.3vw;
      padding-bottom: 1.3vw;
    }

    &:hover {
      background-color: ${(props) => props.color};
      color: #000000;
      transition: ease-in-out 0.15s;
    }
  }

  .title-line {
    font-weight: 400;

    color: #ffffff;
    font-family: "Hind Madurai";

    font-size: 1.8rem !important;
    margin-bottom: 0px;
  }

  @media (min-width: ${breakpoints.m}) {
    padding: 160px 112px 0px 112px;
    justify-content: space-between;

    .gptw {
      display: block;
    }

    .gptw img {
      width: 10.209vw;
      height: 16.667vw;
    }

    .title-line {
      font-size: 48px !important;
      line-height: 68px;
    }

    .title-marg {
    }

    .text-container {
      max-width: none;
      justify-content: flex-start;
      height: 100%;
      padding-bottom: 0px;

      .text {
        font-size: 22px;
        margin-top: 22px;
        line-height: 40px;

        @media (min-width: ${breakpoints.xl}) {
          font-size: 1.527vw;
        }

        @media (min-width: ${breakpoints.xxl}) {
          font-size: 1.375vw;
        }

        @media (min-width: ${breakpoints.ul}) {
          font-size: 1.1458vw;
        }
      }

      button {
        font-size: 14px;
        margin-top: 40px;
        width: max-content;
        padding: 0.8vw 3.88vw;
        line-height: normal;

        @media (min-width: ${breakpoints.m}) {
          font-size: 1.814vw;
        }

        @media (min-width: ${breakpoints.l}) {
          font-size: 1.5vw;
        }

        @media (min-width: ${breakpoints.xl}) {
          font-size: 1.25vw;
        }

        @media (min-width: ${breakpoints.xxl}) {
          font-size: 1.125vw;
        }

        @media (min-width: ${breakpoints.ul}) {
          font-size: 0.9375vw;
        }
      }
    }
  }

  @media (min-width: ${breakpoints.ul}) {
    .text-container {
      margin-top: 4vh;
    }
  }

  /* ${({ id }) =>
		id === 2 &&
		`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  height:100vh;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 1) 0%, 
    rgba(0, 0, 0, 0.75) 60%, 
    rgba(0, 0, 0, 0) 100% 
  ) !important;
  color: white;
  `} */
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default () => null;
